import './FilterField.scss';

import { useSelector } from "react-redux";

import { useApplyFilters } from "../../hooks/useApplyFilters";

import { Filter } from "../Filter/Filter";
import { MultiSelectFilter } from "../Filter/Filter";
import { DateRangeFilter } from "../Filter/Filter";
import { SearchInput } from "../Dropdowns/Dropdowns";

export const FilterField = ({ label, name, type, propertyLabel, componentId, filterKey, filterStructure }) => {
    const {
        value: tempFilters,
        handleChange,
    } = useApplyFilters({ componentId });

    const token = useSelector((state) => state.auth.token);
    const hydratedOptions = useSelector((s) => s.filterOptions.options[filterKey] || []);
    const url = typeof filterStructure?.options === 'string' ? filterStructure.options : null;

    const value = tempFilters && tempFilters[filterKey] !== undefined
        ? tempFilters[filterKey]
        : null;

    const multiValue = Array.isArray(value) ? value : [];

    return (
        <div className="filter-field">
            <div className="filter-field_container">
                <div className="filter-field_header">
                    <label className="filter-field_label">
                        {label}
                    </label>
                </div>
                <div className="filter-field_main">
                    {type === 'boolean' && (
                        <Filter
                            propertyLabel={propertyLabel}
                            value={value}
                            options={hydratedOptions}
                            onChange={(newValue) => handleChange(filterKey, newValue)}
                            token={token}
                            url={url}
                            fieldName={name}
                        />
                    )}
                    {type === 'string_array' && (
                        <SearchInput
                            value={value}
                            placeholder={propertyLabel}
                            onChange={(newValue) => handleChange(filterKey, newValue)}
                        />
                    )}
                    {type === 'single_choice_enum' && (
                        <MultiSelectFilter
                            propertyLabel={propertyLabel}
                            value={multiValue}
                            options={hydratedOptions}
                            onChange={(newValue) => handleChange(filterKey, newValue)}
                            token={token}
                            url={url}
                            fieldName={name}
                        />
                    )}
                    {type === 'datetime' && (
                        <DateRangeFilter
                            value={value}
                            onChange={(newValue) => handleChange(filterKey, newValue)}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};